import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';
import { Form } from 'antd';
import { toString, forEach } from 'lodash';
import validator from 'validator';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import helpers from 'utils/helpers';
import { getTermsUrl, getPrivacyUrl, openPopupWindow } from 'utils/links';
import { registerRequest, googleLoginRequest } from 'ducks/auth';

import {
  FormTitle,
  StyledInput,
  StyledFormItem,
  StyledButton,
  StyledPasswordInput
} from 'components/Styled';

class Register extends Component {
  state = {
    email: '',
    password: '',
    promo: ''
  };

  gtmEvents = {
    // reserve use
    // email: `Inputted Login Email`
  };

  handleTextInputChange = (value, name) => {
    this.setState({
      [name]: value
    });
  };

  handleTextInputBlur = name => {
    if (this.gtmEvents[name]) {
      window.dataLayer.push({
        event: this.gtmEvents[name],
        loginInput: toString(this.state[name])
      });
    }

    this.setState({
      [name + 'Status']: this.validateError(name) ? 'error' : '',
      [name + 'Help']: this.validateError(name)
    });
  };

  validateType = {
    email: 'email',
    password: 'password'
  };

  validate = () => {
    const fields = ['email'];

    const states = {};
    forEach(fields, field => {
      states[field + 'Changed'] = true;
      states[field + 'Status'] = this.validateError(field) ? 'error' : '';
      states[field + 'Help'] = this.validateError(field);
    });

    this.setState(states);

    for (var i = 0; i < fields.length; i++) {
      if (this.validateError(fields[i])) {
        return false;
      }
    }
    return true;
  };

  validateError = name => {
    let patterns;
    const value = toString(this.state[name]);

    switch (this.validateType[name]) {
      case 'password':
        if (value?.trim() === '') {
          return `auth.err_msg.${name}.empty`;
        }
        return null;
      case 'chars':
        patterns = /^[A-Z\s\-.']+$/i;

        if (validator.isEmpty(value, { ignore_whitespace: true })) {
          return `auth.err_msg.${name}.empty`;
        }
        if (!patterns.test(value)) {
          return `auth.err_msg.${name}.format`;
        }
        return null;
      case 'email':
        if (validator.isEmpty(value, { ignore_whitespace: true })) {
          return `auth.err_msg.${name}.empty`;
        }
        if (!validator.isEmail(value)) {
          return `auth.err_msg.${name}.format`;
        }

        return null;
      default:
        return null;
    }
  };

  handleAction = () => {
    if (!this.validate()) {
      return helpers.scrollToError();
    }

    this.props.registerRequest({
      email: this.state.email,
      promo: this.state.promo,
      password: this.state.password
    });
  };

  onSignIn = googleUser => {
    this.props.googleLoginRequest(googleUser);
  };

  toLogin = () => {
    this.props.onPageChange('login', {
      email: this.state.email
    });
  };

  componentDidMount() {
    window.location.href = 'https://ship.spaceshipapp.com/signup';
  }

  handleTermsClick = e => {
    e.preventDefault();
    const lang = helpers.getCurrentLang();
    const country = helpers.getCurrentCountry(true);
    const url = getTermsUrl(lang, country);
    openPopupWindow(url);
  };

  handlePrivacyClick = e => {
    e.preventDefault();
    const lang = helpers.getCurrentLang();
    const country = helpers.getCurrentCountry(true);
    const url = getPrivacyUrl(lang, country);
    openPopupWindow(url);
  };

  render() {
    return (
      <div
        style={{
          backgroundColor: '#fafafa',
          minHeight: '100%'
        }}>
        <div style={{ padding: '50px 0 45px', textAlign: 'center' }}>
          <div style={{ fontSize: '20px', fontWeight: 700 }}>
            {this.props.t('auth.login.free_register')}
          </div>
          <div style={{ fontSize: '12px', paddingTop: '5px' }}>
            {this.props.t('auth.register.register_text')}
          </div>
        </div>
        {this.state.banner && (
          <div style={{ textAlign: 'center', margin: '-26px -15px 10px' }}>
            {helpers.responsiveImage(
              {
                '1x': `https://spaceship-product-images.s3.ap-east-1.amazonaws.com/marketing_images/${
                  this.state.banner
                }-${this.props.t('key')}.jpg`,
                '2x': `https://spaceship-product-images.s3.ap-east-1.amazonaws.com/marketing_images/${
                  this.state.banner
                }-${this.props.t('key')}@2x.jpg`,
                '3x': `https://spaceship-product-images.s3.ap-east-1.amazonaws.com/marketing_images/${
                  this.state.banner
                }-${this.props.t('key')}@3x.jpg`
              },
              '',
              375
            )}
          </div>
        )}
        <Form>
          <div style={{ padding: '' }}>
            <FormTitle>Email</FormTitle>
            <StyledFormItem
              validateStatus={this.state['emailStatus'] || ''}
              help={this.props.t(this.state['emailHelp'])}>
              <StyledInput
                size="large"
                value={this.state['email']}
                onChange={e => {
                  this.handleTextInputChange(e.target.value, 'email');
                }}
                onBlur={e => {
                  this.handleTextInputBlur('email');
                }}
              />
            </StyledFormItem>
            <FormTitle style={{ paddingTop: '20px' }}>
              {this.props.t('auth.login.password')}
            </FormTitle>
            <StyledFormItem
              validateStatus={this.state['passwordStatus'] || ''}
              help={this.props.t(this.state['passwordHelp'])}>
              <StyledPasswordInput
                size="large"
                value={this.state['password']}
                onChange={e => {
                  this.handleTextInputChange(e.target.value, 'password');
                }}
                onBlur={e => {
                  this.handleTextInputBlur('password');
                }}
              />
            </StyledFormItem>
          </div>
          <div style={{ padding: '15px 0' }}>
            <StyledButton
              onClick={this.handleAction}
              type="primary"
              loading={this.props.loading}
              htmlType="submit"
              shadow="true"
              block>
              {this.props.t('auth.register.register')}
            </StyledButton>
          </div>
          <div
            style={{
              textAlign: 'center',
              color: '#2C2C2E',
              fontSize: '10px',
              paddingTop: '17px'
            }}>
            {this.props.t('auth.register.terms_and_privacy.accept')}
            <a
              href=""
              onClick={this.handleTermsClick}
              style={{ textDecoration: 'underline' }}
              rel="noopener noreferrer">
              {this.props.t('auth.register.terms_and_privacy.terms')}
            </a>
            {this.props.t('auth.register.terms_and_privacy.and')}
            <a
              href=""
              onClick={this.handlePrivacyClick}
              style={{ textDecoration: 'underline' }}
              rel="noopener noreferrer">
              {this.props.t('auth.register.terms_and_privacy.privacy')}
            </a>
          </div>
          <div style={{ paddingTop: '65px', textAlign: 'center' }}>
            {this.props.t('auth.register.already_register')}
            <span
              style={{
                color: '#9900A5',
                textDecoration: 'underline',
                cursor: 'pointer'
              }}
              onClick={this.toLogin}>
              {this.props.t('auth.register.please_login')}
            </span>
          </div>
        </Form>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    user: state.auth.user || false,
    loading: !!state.auth.loading
  };
};

const mapDispatchToProps = {
  registerRequest,
  googleLoginRequest
};

export default withTranslation()(
  connect(mapStateToProps, mapDispatchToProps)(withRouter(Register))
);
